import React from 'react';
import PropTypes from 'prop-types';
import {isEqual} from 'lodash/lang';
import {getAccreditationBodiesHaveStandardsMncb} from 'api/accreditation-bodies';
import {SelectSearchBase} from 'components/Forms/FormBases';

class SelectABHasStandardsMncb extends React.Component {
  static defaultProps = {
    name: 'accreditation_bodies_id',
    placeholder: 'Accreditation Bodies',
    cacheOptions: true,
    defaultOptions: true,
    filters: {},
    onChange: () => {},
    getOptionLabel: (option) => option.accreditation_bodies_name,
    getOptionValue: (option) => option.accreditation_bodies_id,
  };

  constructor(props) {
    super(props);

    this.state = {
      options: [],
      value: props.defaultValue || '',
      inputValue: '',
    };
  }

  componentDidMount() {
    this._isMounted = true;

    const {defaultOptions} = this.props;

    if (defaultOptions) this.loadOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    const {inputValue} = this.state;

    if (!isEqual(prevProps.filters, this.props.filters)) {
      this.setState(
        {
          value: '',
          options: [],
        },
        this.loadOptions
      );
    }

    if (!isEqual(prevState.inputValue, inputValue)) {
      this.loadOptions();
    }
  }

  loadOptions = async () => {
    const {inputValue} = this.state;
    const {isDisabled, filters} = this.props;
    if (isDisabled) return false;

    await this.setState({isLoading: true});
    const {cbId} = this.props;
    const {data} = await getAccreditationBodiesHaveStandardsMncb(cbId, {
      ...filters,
      order: 'ASC',
      order_by: 'accreditation_bodies_name',
      search: inputValue,
    });

    if (!this._isMounted) return false; // Check Mounted

    this.setState({
      options: data,
      isLoading: false,
    });
  };

  render() {
    const {value, defaultOptions, filters, onChange, ...rest} = this.props;

    return (
      <SelectSearchBase
        isClearable={true}
        value={this.state.value}
        options={this.state.options}
        isLoading={this.state.isLoading}
        getOptionLabel={(option) => option.accreditation_bodies_name}
        getOptionValue={(option) => option.accreditation_bodies_id}
        onChange={(data) => this.setState({value: data}, onChange(data))}
        onInputChange={(value) => this.setState({inputValue: value})}
        loadOptions={this.loadOptions}
        {...rest}
      />
    );
  }
}

SelectABHasStandardsMncb.propTypes = {
  cbId: PropTypes.string.isRequired,
};

export default SelectABHasStandardsMncb;
